import React from "react";
import { Route, Redirect } from "react-router-dom";
import { isAuthenticated } from "../store/action/auth";
// import useShopifyAccessToken from '../screens/shopify/hooks/useAccessToken';

const PrivateRoute = ({ component: Component, ...rest }) => {
  // useShopifyAccessToken();
  return (
    <Route
      {...rest}
      render={(props) => {
        if (isAuthenticated()) {
          return <Component {...props} />;
        }
        if (arrayOfPaths.includes(props.location.pathname)) {
          return <Redirect to={{ pathname: "/", state: { from: props.location } }} />;
        }
        return <Component {...props} />;
      }}
    />
  );
};

export default PrivateRoute;

const arrayOfPaths = [
  "/overview",
  "/address",
  "/billing",
  "/catalog",
  "/tickets",
  "/form",
  "/integrations",
  "/overview",
  "/setting",
  "/analytics",
  "/api-production-form",
  "/postpaid-registration",
  "/invoices",
];
